import { getAnalytics } from 'firebase/analytics';
import { initializeApp, getApp, getApps } from 'firebase/app';
import { getRemoteConfig, fetchAndActivate } from 'firebase/remote-config';
import { defaultValues } from '@globalConstants';

/** WA */
const mainFirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const MAIN_APP_NAME = '[DEFAULT]';
const mainApp = getApps().find((a) => a.name === MAIN_APP_NAME)
  ? getApp()
  : initializeApp(mainFirebaseConfig);

const mainRemoteConfig = getRemoteConfig(mainApp);

mainRemoteConfig.settings = {
  minimumFetchIntervalMillis: 30000,
};

mainRemoteConfig.defaultConfig = defaultValues;

fetchAndActivate(mainRemoteConfig)
  .then(() => {
    console.log('Remote Config principal actualizado');
  })
  .catch((error) => {
    console.error('Error actualizando Remote Config principal', error);
  });

const analytics = getAnalytics(mainApp);

/** APP */
const secondaryFirebaseConfig = {
  apiKey: process.env.REACT_APP_WEB_FIREBASE_API_KEY,
  authDomain: `${process.env.REACT_APP_WEB_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  projectId: process.env.REACT_APP_WEB_FIREBASE_PROJECT_ID,
  storageBucket: `${process.env.REACT_APP_WEB_FIREBASE_PROJECT_ID}.appspot.com`,
  messagingSenderId: process.env.REACT_APP_WEB_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_WEB_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_WEB_FIREBASE_MEASUREMENT_ID,
};

const SECOND_APP_NAME = 'secondary';
const secondaryApp = getApps().find((a) => a.name === SECOND_APP_NAME)
  ? getApp(SECOND_APP_NAME)
  : initializeApp(secondaryFirebaseConfig, SECOND_APP_NAME);

const secondRemoteConfig = getRemoteConfig(secondaryApp);

secondRemoteConfig.settings = {
  minimumFetchIntervalMillis: 10000,
};

fetchAndActivate(secondRemoteConfig)
  .then(() => {
    console.log('Remote Config secundaria actualizada');
  })
  .catch((error) => {
    console.error('Error actualizando Remote Config secundaria', error);
  });

export { mainApp, mainRemoteConfig, analytics, secondaryApp, secondRemoteConfig };
